/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NoticeListResponse { 
    contentEn?: string;
    contentSk?: string;
    id?: string;
    noticeType?: NoticeListResponse.NoticeTypeEnum;
    priority?: NoticeListResponse.PriorityEnum;
}
export namespace NoticeListResponse {
    export type NoticeTypeEnum = 'INFO' | 'WARNING' | 'ERROR';
    export const NoticeTypeEnum = {
        Info: 'INFO' as NoticeTypeEnum,
        Warning: 'WARNING' as NoticeTypeEnum,
        Error: 'ERROR' as NoticeTypeEnum
    };
    export type PriorityEnum = 'LOW' | 'MEDIUM' | 'HIGH';
    export const PriorityEnum = {
        Low: 'LOW' as PriorityEnum,
        Medium: 'MEDIUM' as PriorityEnum,
        High: 'HIGH' as PriorityEnum
    };
}


